import React, { useState, useEffect } from 'react';
import Service from '../../apiService';

function useDataFetching({ url = '', data = {}, method = '' }) {
  const [ loading, setLoading ] = useState(true);
  const [ results, setResults ] = useState([]);
  const [ error, setError ] = useState('');

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await Service.fetch({ url, data, method });
        if (response) {
          setResults(response);
        }
      } catch (catchError) {
        setError(catchError);
      }
      setLoading(false);
    }
    fetchData();
  }, []);

  return {
    error,
    loading,
    results,
  };
}

export default useDataFetching;
